import { ISheet } from './ISheet';
export interface ISpreadSheet {
    sheets: ISheet[];
}
